module.exports = __webpack_public_path__ + "static/img/so3_4.e908a77.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/solution/pic/so3_4.jpg
// module id = 1w58
// module chunks = 11